import { Link } from 'react-router-dom';
import { useHistory } from '@/hooks/useHistory';
import { getMediaByIds } from '@/utils/media';

export default function HistoryPanel() {
  const { history, clearHistory } = useHistory();
  const items = getMediaByIds(history);

  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-4 animate-fade-up md:p-5">
      <div className="mb-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="flex h-7 w-7 items-center justify-center rounded-md bg-primary-100 text-primary-600">
            <i className="ri-history-line"></i>
          </span>
          <h2 className="font-heading text-lg font-bold text-foreground-950">最近浏览</h2>
        </div>
        {items.length > 0 && (
          <button onClick={clearHistory} className="text-xs font-medium text-foreground-400 hover:text-accent-600">
            清空
          </button>
        )}
      </div>
      {items.length === 0 ? (
        <p className="py-4 text-center text-sm text-foreground-400">还没有浏览记录，去发现好剧吧</p>
      ) : (
        <div className="flex flex-col gap-2">
          {items.map((item) => (
            <Link
              key={item.id}
              to={`/detail/${item.id}`}
              className="flex items-center gap-3 rounded-md p-1.5 hover:bg-background-100"
            >
              <span className="h-12 w-9 shrink-0 overflow-hidden rounded-md bg-background-200">
                <img src={item.cover} alt={item.title} className="h-full w-full object-cover" />
              </span>
              <span className="min-w-0">
                <span className="block truncate text-sm font-medium text-foreground-900">{item.title}</span>
                <span className="text-xs text-foreground-500">
                  {item.type === 'movie' ? '电影' : '电视剧'} · {item.year}
                </span>
              </span>
            </Link>
          ))}
        </div>
      )}
    </section>
  );
}